import React, { } from 'react'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { BackButton } from '../segment.styled'
import { DashboardCategory } from '../../../constants/DashboardConf'
import DashboardSetting from '../../DashboardSetting/DashboardSetting'
import { useSelector } from 'react-redux'

function SegmentPreview (props) {
  const { goBackPath, viewOnly } = props
  const { t: ln_t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const { state } = location || {}
  const { segmentInfo } = state || {}
  const user = useSelector(state => state.user)
  const { nowBrand, brands } = user || {}
  const nowBrandData = brands?.find(item => item.id === nowBrand)

  const goBack = () => navigate(goBackPath, { state: { type: 'segment', prevViewOnly: viewOnly } })

  return (
    <>
      <BackButton>
        <ArrowLeftOutlined onClick={goBack} />
        {ln_t('segment.segment')} {ln_t('util.preview')}
      </BackButton>
      <DashboardSetting
        fixedData={nowBrandData}
        type={DashboardCategory.SEGMENT}
        content={segmentInfo?.demographics}
        setting={segmentInfo?.dashboardSetting}
        noHeader
        // useFakeData
        useSetting
      />
    </>
  )
}

export default SegmentPreview
